import { useSetAtom } from 'jotai';
import { LucideChevronRight, LucideMapPin } from 'lucide-react';

import { $location } from '../../../../shared/state/location.state';
import { RenderMode } from '../../../assistant/_components/chat/entity-reference/types';

interface FacilityData {
  id: string;
  name: string;
  type?: string;
  address?: string;
}

interface FacilityReferenceProps extends FacilityData {
  mode: RenderMode | string;
}

export function FacilityReference({
  mode,
  id: _id,
  name,
  type,
  address,
}: FacilityReferenceProps) {
  const setLocation = useSetAtom($location);

  const handleClick = () => {
    setLocation({ pathname: `/facilities/management` });
  };

  if (mode === RenderMode.CARD || mode === 'card') {
    return (
      <span
        className="group my-1 inline-flex max-w-sm min-w-[280px] cursor-pointer items-center gap-3 rounded-lg border border-neutral/20 bg-white px-3 py-2.5 transition-all hover:border-primary/30 hover:shadow-md"
        onClick={handleClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
          }
        }}
      >
        <span className="flex-1">
          <span className="block text-base font-semibold text-neutral">
            {name}
          </span>
          {type && (
            <span className="mt-0.5 block text-sm text-neutral/60">{type}</span>
          )}
          {address && (
            <span className="mt-1 flex items-center gap-1 text-xs text-neutral/50">
              <LucideMapPin className="h-3.5 w-3.5" />
              {address}
            </span>
          )}
        </span>
        <LucideChevronRight className="h-5 w-5 shrink-0 text-neutral/40 transition-colors group-hover:text-primary" />
      </span>
    );
  }

  if (mode === RenderMode.LINK || mode === 'link') {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-1 font-medium text-primary hover:text-primary-darker hover:underline"
      >
        <span>{name}</span>
      </button>
    );
  }

  return null;
}
